import {
    DateTimeUtils, Table,
    EllipsisDropdown,
    ControlledPopup,
    LinkedAccount,
    ClippedContent,
    ButtonLink
} from "dyl-components";
import {
    DropdownItem,
    Dropdown,
    Header,
    Icon
} from "semantic-ui-react";
import { Link } from 'react-router-dom';
import FileUtils from 'utils/FileUtils';
import { useSelector } from 'react-redux';
import RestrictedView from "shared/RestrictedView";
import { USER_PERMISSIONS } from "dyl-components";

const UploadRow = ({ uploadData, onRemove, account_id }) => {
    const account = useSelector((state) => state.account?.account);
    const contact = useSelector((state) => state.contact?.contact);
    const userName = `${uploadData.first_name} ${uploadData.last_name}`;
    const openDocument = (url) => {
        window.open(
            url,
            "_blank",
            "location=yes,height=770,width=770,scrollbars=yes,status=yes"
        );
    }
    const iconDisplay = (fileName) => {
        const fileExtension = fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 2);
        if(fileExtension === "pdf"){
            return 'file pdf outline';
        }
        if(fileExtension === "jpg" || fileExtension === "jpeg" || fileExtension === "png"){
            return 'image';
        }
    }
    return (
        <Table.Row>
            <Table.Cell>
                <div><b>{DateTimeUtils.formatEpoch(uploadData.created, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(uploadData.created, DateTimeUtils.TIME_FORMAT)}</div>
                </Table.Cell>
            <Table.Cell>
                <ButtonLink
                    onClick={() => { openDocument(uploadData.url) }}
                    noPadding
                    style={{maxWidth:500}}
                >
                    <ClippedContent popupContent={uploadData.name}>
                        <Icon name={iconDisplay(uploadData.file_id)} color="black"/>
                        {uploadData.name}
                    </ClippedContent>
                </ButtonLink>   
            </Table.Cell>
            <Table.Cell>{FileUtils.getFileSize(uploadData.size)}</Table.Cell>
            <Table.Cell>
                {uploadData.email !== "system" ?
                    <LinkedAccount
                        maxWidth={'9em'}
                        account={userName}
                        subtitle={uploadData.email}
                        linkToAccount={<Link target={'_blank'} to={`/settings/users/${uploadData.created_user_id}/general`}>{userName}</Link>}
                    />
                :
                    <Icon
                    className='fas fa-robot AutomationIcon'
                    circular
                    size='large' />
                }       
            </Table.Cell>
            <Table.Cell>
                <EllipsisDropdown>
                    <DropdownItem
                        style={{ cursor: "pointer" }}
                        text="Download"
                        icon="fa-solid fa-download"
                        onClick={() => openDocument(uploadData.url)}
                    />
                    {uploadData.email !== "system" &&
                        <RestrictedView type="controlledPopupDisabled" userPermission={account_id ? USER_PERMISSIONS.ACCOUNT_EDIT : USER_PERMISSIONS.CONTACTS_EDIT} userRestrict assignmentIds={account_id ? [(account?.assignees?.owner_id || 0), (account?.assignees?.coowner_id || 0)] : [(contact?.assignees?.owner_id || 0), (contact?.assignees?.coowner_id || 0)]}>
                            <ControlledPopup
                                header={
                                    <Header as="h4" textAlign="center">
                                        Are you sure?
                                    </Header>
                                }
                                trigger={
                                    <Dropdown.Item
                                        icon="fas fa-trash-alt"
                                        text="Delete"
                                    />
                                }
                                onConfirm={() => onRemove(uploadData.id)}
                                inverted
                            />
                        </RestrictedView>
                    }
                </EllipsisDropdown>
            </Table.Cell>
        </Table.Row>
    );
};

export default UploadRow;
